import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// import { useAuth } from '../contexts/AuthContext'; // <-- REMOVE THIS

// --- ★ FIX ★ ---
// Accept 'session' and 'loading' as props from App.js
const ProtectedRoute = ({ session, loading }) => {
  // const { session, loading } = useAuth(); // <-- REMOVE THIS

  if (loading) {
    return <div style={{ padding: '50px', textAlign: 'center' }}>Loading Session...</div>;
  }

  if (!session) {
    // User is not authenticated, redirect to login
    return <Navigate to="/login" replace />;
  }

  // User is authenticated, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;